import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Fade,
  FormControl,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../styles/layout/header.module.scss";
import logo from "../../public/assets/images/main_logo.png";
import noUser from "../../public/assets/images/profile_img.svg";
import HeaderSearchIcon from "../../ui/Icons/HeaderSearchIcon";
import HeaderMessageIcon from "../../ui/Icons/HeaderMessageIcon";
import HeaderNotificationIcon from "../../ui/Icons/HeaderNotificationIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import BlueDoubleTickIcon from "../../ui/Icons/BlueDoubleTickIcon";
import assest from "../../json/assest";
import useFetch, { usePost } from "../../hooks/api/useFetch";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../lib/functions/utils.lib";
import axiosInstance from "../../api/axiosInstance";
import { parseCookies } from "nookies";
import { concatHostAndImagePath } from "../../lib/functions/utils.lib";
import {
  setCheck,
  updateQuery,
} from "../../redux-toolkit/slices/searchQuery.slice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import NOprofileImage from "../../public/assets/images/no-image.svg";

const messageNotificatonLoop = [
  {
    icon: `${assest.msgReminder}`,
    msgText: (
      <p>
        <strong>REMINDER:</strong> Please take action on this pending message.{" "}
        <span>
          <strong>VSID #9782</strong>
        </span>
      </p>
    ),
    time: "Right now",
  },
  {
    icon: `${assest.msgQc}`,
    msgText: <p>QC Agent messaged Partner (VSID: #4541).</p>,
    time: "1 min ago",
  },
  {
    icon: `${assest.msgResolve}`,
    msgText: <p>Manager resolved a message that they initiated.</p>,
    time: "2 min ago",
  },
  {
    icon: `${assest.msgResolve}`,
    msgText: <p>Manager resolved a message that you initiated.</p>,
    time: "3 min ago",
  },
  {
    icon: `${assest.msgResolve}`,
    msgText: <p>Manager resolved a message initiated by Editor.</p>,
    time: "4 min ago",
  },
  {
    icon: `${assest.msgReopen}`,
    msgText: <p>Manager reopened a message resolved by Editor.</p>,
    time: "5 min ago",
  },
  {
    icon: `${assest.msgReopen}`,
    msgText: <p>Manager reopened a message resolved by you.</p>,
    time: "6 min ago",
  },
  {
    icon: `${assest.msgReopen}`,
    msgText: <p>Manager reopened a message that they resolved.</p>,
    time: "7 min ago",
  },
  {
    icon: `${assest.msgEditor}`,
    msgText: <p>Editor responded to your message.</p>,
    time: "8 min ago",
  },
  {
    icon: `${assest.msgEditor}`,
    msgText: <p>Editor responded to your message.</p>,
    time: "15 min ago",
  },
  {
    icon: `${assest.msgEditor}`,
    msgText: <p>Editor responded to a message sent by Manager.</p>,
    time: "17 min ago",
  },
  {
    icon: `${assest.msgEditor}`,
    msgText: <p>Editor responded to a message that they sent.</p>,
    time: "18 min ago",
  },
  {
    icon: `${assest.managerOpen}`,
    msgText: <p>Manager opened a new support ticket (ID #SR59).</p>,
    time: "January 25, 2023",
  },
  {
    icon: `${assest.managerReopen}`,
    msgText: (
      <p>
        Manager reopened a support ticket they resolved.{" "}
        <span>(ID #SR59).</span>
      </p>
    ),
    time: "January 23, 2023",
  },
  {
    icon: `${assest.managerResolve}`,
    msgText: (
      <p>
        Manager resolved a support ticket they opened <span>(ID #SR59).</span>
      </p>
    ),
    time: "January 27, 2023",
  },
  {
    icon: `${assest.managerRespond}`,
    msgText: <p>Manager responded to your message (ID #SR59).</p>,
    time: "January 22, 2023",
  },
  {
    icon: `${assest.managerOpen}`,
    msgText: <p>Manager responded to a message they sent (ID #SR59).</p>,
    time: "January 21, 2023",
  },
];

const notificationLoop = [
  {
    icon: `${assest.Notiuserbatch}`,
    msgText: <p>QC Agent changed his physical address.</p>,
    time: "Right now",
    type: "qcAgentNum",
  },
  {
    icon: `${assest.Notiusersetting}`,
    msgText: <p>Manager changed his phone number.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.Notidoubleuser}`,
    msgText: <p>Partner changed his physical address.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.Notimoreuser}`,
    msgText: <p>Member changed his physical address.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.Notibuyer}`,
    msgText: <p>Content Buyer changed his physical address.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.Notiusernote}`,
    msgText: <p>Copywriter changed his physical address.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.Notivideocut}`,
    msgText: <p>Editor changed his physical address.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.msgQc}`,
    msgText: <p>QC Agent messaged Manager.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.msgResolve}`,
    msgText: <p>Manager resolved a message that they initiated.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.msgReopen}`,
    msgText: <p>Manager reopened a message resolved by Editor.</p>,
    time: "Right now",
  },
  {
    icon: `${assest.msgEditor}`,
    msgText: <p>Editor responded to a message sent by Manager.</p>,
    time: "Right now",
    type: "editorSendManager",
  },
  {
    icon: `${assest.Notivideo}`,
    msgText: <p>Manager has added an original video file.</p>,
    time: "Right now",
  },
];

export default function SuperAdminHeader() {
  const navigate = useNavigate();

  const [backdropOpen, setBackdropOpen] = useState(false);
  const [searchState, setSearchState] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [inSearchPage, setInSearchpage] = useState(true);

  const { query, check } = useAppSelector((s) => s.searchQuerySlice);

  const [anchorEl, setMessageAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setMessageAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setMessageAnchorEl(null);
  };

  const [notificationAnchorEl, setNotificationAnchorEl1] = React.useState(null);
  const open1 = Boolean(notificationAnchorEl);
  const handleClick1 = (event) => {
    setNotificationAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setNotificationAnchorEl1(null);
  };

  const cookies = parseCookies();
  const userData = JSON.parse(cookies?.userdetails || "{}");
  const dispatch = useAppDispatch();

  const {
    data: adminData,
    isLoading: adminIsLoading,
    isSuccess: adminIsSuccess,
    refetch: adminRefetch,
  } = useFetch(["admin", userData?.id], `admin/user?user_id=${userData?.id}`);

  const {
    data: notificationsList,
    isSuccess: notificationsListIsSuccess,
    isError: notificationsListIsError,
    isLoading: notificationsListIsLoading,
    refetch: refetchNotificationsList,
  } = usePost(["unseen-notifications"], `admin/notifications`, {
    seen: 0,
    archive: 0,
  });

  const {
    data: messageNotificationsList,
    isSuccess: messageNotificationsListIsSuccess,
    isError: messageNotificationsListIsError,
    isLoading: messageNotificationsListIsLoading,
    refetch: refetchMessageNotificationsList,
  } = usePost(["unseen-message-notifications"], `admin/notifications`, {
    notification_type_id: "47, 48",
    seen: 0,
    archive: 0,
  });

  const updateNotification = async (data) => {
    await axiosInstance
      .post("admin/notification-status-update", data)
      .then((res) => {
        refetchNotificationsList();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const updateNotificationSeen = (notification) => {
    updateNotification({
      notification_id: notification?.id,

      seen: notification?.seen ? 0 : 1,
    });
  };
  const updateNotificationArchive = (notification) => {
    updateNotification({
      notification_id: notification?.id,
      archive: 1,
    });
  };

  const updateNotificationReadAll = () => {
    updateNotification({ read_all: "yes" });
  };

  const handleSearch = () => {
    navigate("/searchresult");
    dispatch(updateQuery(query));
    if (query) {
      dispatch(setCheck(true));
    }
  };

  const handleClear = () => {
    navigate("/");
    dispatch(updateQuery(""));
    if (query) {
      dispatch(setCheck(false));
    }
  };

  React.useEffect(() => {
    if (location.pathname !== "/searchresult") {
      dispatch(updateQuery(""));
      dispatch(setCheck(false));
    }
  }, [dispatch, location.pathname]);

  React.useEffect(() => {
    if (location.pathname === "/searchresult") {
      setInSearchpage(false);
      if (query?.length > 1) {
        dispatch(setCheck(true));
      }
    }
  }, [dispatch, location.pathname]);

  const handleFade = () => {
    setSearchState(false);
    setBackdropOpen(!backdropOpen);
    if (location.pathname !== "/searchresult") {
      dispatch(updateQuery(""));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch()
  };

  return (
    <AppBar
      component={"nav"}
      position="static"
      elevation={0}
      className={styles.headerAppbar}
    >
      <Toolbar>
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.mainHeader}
        >
          <Box className={styles.headerLeft}>
            <Link to="/">
              <img src={logo} alt="" width={133} height={29} />
            </Link>
          </Box>
          <Box className={styles.headerRight}>
            <form action="" onSubmit={handleSubmit}>
            <Box
              onSubmit={handleSubmit}
              className={`${styles.search_box} ${
                searchState && inSearchPage ? `${styles.openSearchBox}` : ""
              }`}
            >
              <TextField
                autoComplete="off"
                label=""
                id="outlined-size-normal"
                placeholder="Enter an email address, submitter name, VSID to search..."
                onClick={() => {
                  setBackdropOpen(true);
                  setSearchState(true);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      className={query ? styles.startAdmnt : undefined}
                    >
                      <HeaderSearchIcon />
                    </InputAdornment>
                  ),

                  endAdornment:
                    backdropOpen && inSearchPage ? (
                      <InputAdornment position="end">
                        {!check ? (
                          <Button
                            onClick={handleSearch}
                            disabled={
                              query?.length === 0 || query?.length === undefined
                            }
                          >
                            Search
                          </Button>
                        ) : (
                          <Button onClick={handleClear} className={styles.clearBtn}>clear</Button>
                        )}
                      </InputAdornment>
                    ) : location.pathname === "/searchresult" &&
                      query?.length > 0 ? (
                      <Button onClick={handleClear} className={styles.clearBtn}>clear</Button>
                    ) : null,
                }}
                value={query}
                // onChange={(e) => setSearchValue(e.target.value)}
                onChange={(e) => dispatch(updateQuery(e.target.value))}
                sx={
                  query
                    ? {
                        border: "1px solid #111AE9 !important",
                        borderRadius: "6px",                        
                      }
                    : undefined
                }
              />
              <Fade
                in={backdropOpen && inSearchPage}
                unmountOnExit
                mountOnEnter
                timeout={{ enter: 500, exit: 800, appear: 400 }}
              >
                <Box className={styles.srchBackdrop} onClick={handleFade}></Box>
              </Fade>
            </Box>
            </form>

            <Box className={styles.headerprofileSec}>
              <ButtonGroup>
                <Button
                  onClick={handleClick}
                  aria-controls={open ? "message-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <HeaderMessageIcon />
                  {messageNotificationsList?.data?.data?.length ? (
                    <span></span>
                  ) : null}
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  id="message-menu"
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      maxWidth: "447px",
                      borderRadius: "13px",
                      width: "100%",
                      "& .MuiList-root": {
                        padding: "0",
                      },
                      "& .scrollbar-container": {
                        "& .ps__rail-x": {
                          display: "none",
                        },
                        "& .ps__rail-y": {
                          right: "5px !important",
                        },
                      },
                      "& .msgContent": {
                        width: "calc(100% - 26px)",
                      },
                    },
                  }}
                  className={styles.menuPop}
                  transformOrigin={{
                    horizontal: "right",
                    vertical: "top",
                  }}
                  anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    className={styles.popupHeader}
                  >
                    <Typography variant="caption">Messages</Typography>
                    <Button onClick={handleClose}>
                      <img
                        src={assest.iconCross}
                        width={9}
                        height={9}
                        alt="icon"
                      />
                    </Button>
                  </Stack>
                  <PerfectScrollbar>
                    <Box className={styles.listBox}>
                      {messageNotificationsListIsLoading ? (
                        <Typography variant="body1">Loading...</Typography>
                      ) : messageNotificationsListIsSuccess ? (
                        messageNotificationsList?.data?.data?.length ? (
                          messageNotificationsList?.data?.data?.map(
                            (item, index) => (
                              <MenuItem
                                key={index}
                                onClick={handleClose}
                                disableGutters
                              >
                                <Stack
                                  direction="row"
                                  className={styles.innerListWrap}
                                >
                                  <img
                                    src={getAbsoluteImageURI(item?.icon)}
                                    width={26}
                                    height={26}
                                    alt="icon"
                                  />
                                  <Box
                                    className={`${styles.msgTxt} msgContent`}
                                  >
                                    <p>{item?.title}</p>
                                    <span>
                                      {getStyledDateTime(item?.created_at)}
                                    </span>
                                  </Box>
                                </Stack>
                              </MenuItem>
                            )
                          )
                        ) : (
                          <Stack
                            justifyContent={"center"}
                            alignItems={"center"}
                            className={styles.noItemForPopup}
                          >
                            <figure>
                              <img
                                src={assest.mail}
                                width={34}
                                height={24}
                                alt="icon"
                              />
                            </figure>
                            <Typography variant="body1">
                              You're all clear - no new notifications
                            </Typography>
                          </Stack>
                        )
                      ) : (
                        ""
                      )}
                    </Box>
                  </PerfectScrollbar>
                  <Stack
                    justifyContent="flex-end"
                    direction="row"
                    className={styles.popupFooter}
                  >
                    <Button onClick={() => navigate("/message")}>
                      Go to My Messages
                    </Button>
                  </Stack>
                </Menu>
                <Button
                  onClick={handleClick1}
                  aria-controls={open1 ? "notification-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                >
                  <HeaderNotificationIcon />
                  {notificationsList?.data?.data?.length ? <span></span> : null}
                </Button>
                <Menu
                  anchorEl={notificationAnchorEl}
                  id="notification-menu"
                  open={open1}
                  onClose={handleClose1}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      maxWidth: "447px",
                      borderRadius: "13px",
                      width: "100%",
                      "& .MuiList-root": {
                        padding: "0",
                      },
                      "& .scrollbar-container": {
                        "& .ps__rail-x": {
                          display: "none",
                        },
                        "& .ps__rail-y": {
                          right: "5px !important",
                        },
                      },
                      "& .msgContent": {
                        width: "calc(100% - 26px)",
                      },
                    },
                  }}
                  className={styles.menuPop}
                  // transformOrigin={{
                  //   horizontal: "right",
                  //   vertical: "top",
                  // }}
                  // anchorOrigin={{
                  //   horizontal: "right",
                  //   vertical: "bottom",
                  // }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    className={`${styles.popupHeader} ${styles.popupHeaderNotification}`}
                  >
                    <Typography variant="caption">Notification</Typography>
                    <Button onClick={handleClose1}>
                      <img
                        src={assest.iconCross}
                        width={9}
                        height={9}
                        alt="icon"
                      />
                    </Button>
                  </Stack>
                  <PerfectScrollbar>
                    <Box
                      className={`${styles.listBox} ${styles.listBoxNotification}`}
                    >
                      {notificationsListIsLoading ? (
                        <Typography variant="body1">Loading...</Typography>
                      ) : notificationsListIsSuccess ? (
                        notificationsList?.data?.data?.length ? (
                          notificationsList?.data?.data?.map((item, index) => {
                            return (item?.notification_type_id === 47 ||
                              item?.notification_type_id === 48) ===
                              true ? null : (
                              <MenuItem
                                key={index}
                                onClick={handleClose}
                                disableGutters
                              >
                                <Stack
                                  direction="row"
                                  className={styles.innerListWrap}
                                >
                                  <img
                                    src={getAbsoluteImageURI(item?.icon)}
                                    width={26}
                                    height={26}
                                    alt="icon"
                                  />
                                  <Box
                                    className={`${styles.msgTxt} msgContent`}
                                  >
                                    <p>{item?.title}</p>
                                    <span>
                                      {getStyledDateTime(item?.created_at)}
                                    </span>
                                  </Box>
                                </Stack>
                                <Box className={styles.btnOverlay}>
                                  {(item?.notification_type_id === 47 ||
                                    item?.notification_type_id === 48) ===
                                  true ? (
                                    <Link
                                      to={`/${
                                        item?.type === "Message"
                                          ? "message-details"
                                          : "support-details"
                                      }/${item?.inquiry_id}`}
                                    >
                                      <Button>View</Button>
                                    </Link>
                                  ) : (
                                    ""
                                  )}

                                  {item?.seen ? (
                                    item?.archive ? (
                                      <HtmlTooltip
                                        title={
                                          <React.Fragment>
                                            <Typography color="inherit">
                                              Remove
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        placement="top-start"
                                      >
                                        <Button>
                                          <img
                                            src={assest.crossGray}
                                            width={9}
                                            height={9}
                                            alt="icon"
                                          />
                                        </Button>
                                      </HtmlTooltip>
                                    ) : (
                                      <Button
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          updateNotificationArchive(item);
                                        }}
                                      >
                                        Archive
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        updateNotificationSeen(item);
                                      }}
                                    >
                                      Mark as read
                                    </Button>
                                  )}
                                </Box>
                              </MenuItem>
                            );
                          })
                        ) : (
                          <Stack
                            justifyContent={"center"}
                            alignItems={"center"}
                            className={styles.noItemForPopup}
                          >
                            <figure>
                              <img
                                src={assest.iconLgbluetick}
                                width={34}
                                height={19}
                                alt="icon"
                              />
                            </figure>
                            <Typography variant="body1">
                              You're all clear - no new notifications
                            </Typography>
                          </Stack>
                        )
                      ) : (
                        ""
                      )}
                      {/* ======================================= */}
                      {/* ====== FOR NO NOTIFICATION START ====== */}

                      {/* ======================================*/}
                      {/* ====== FOR NO NOTIFICATION END ====== */}

                      {}
                    </Box>
                  </PerfectScrollbar>
                  <Stack
                    justifyContent="flex-end"
                    direction="row"
                    className={`${styles.popupFooter} ${styles.popupFooterNotification}`}
                  >
                    <Button
                      startIcon={<BlueDoubleTickIcon />}
                      className={styles.bluemarkReadBtn}
                      onClick={updateNotificationReadAll}
                    >
                      Mark all as read
                    </Button>
                    <Button onClick={() => navigate("/notification")}>
                      View all notifications
                    </Button>
                  </Stack>
                </Menu>
              </ButtonGroup>
              <Box className={styles.profile_box}>
                <Typography variant="body1">{`${adminData?.data?.name} ${adminData?.data?.last_name}`}</Typography>
                <img
                  src={
                    adminData?.data?.avatar === "users/default.png"
                      ? NOprofileImage
                      : getAbsoluteImageURI(adminData?.data?.avatar)
                  }
                  alt=""
                  width={31}
                  height={31}
                />
                {/* <Typography variant="body1">
                  {`${userdeatails?.name} ${userdeatails?.last_name}`}

                  
                </Typography>
                {userdeatails?.avatar === "users/default.png" ? (
                  <img src={noUser} alt="" width={31} height={31} />
                ) : (
                  <img
                    src={concatHostAndImagePath(userdeatails?.avatar)}
                    alt=""
                    width={31}
                    height={31}
                  />
                )} */}
              </Box>
            </Box>
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
